<div *ngIf="isLoading">Loading Financial Accounts List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="financialAccounts"
        [(ngModel)]="model.financialAccount" [required]="required">
  <option *ngFor="let singleDeliveryMethod of financialAccounts" [ngValue]="singleDeliveryMethod">
    {{ singleDeliveryMethod.code }} : {{ singleDeliveryMethod.name }}
  </option>
</select>
